export const redirectToEditUrl = (params: any = {}) => {
  return `/recommendation/edit/${params.type}/${params.id}`
}
